/**
 * DescriptionContentContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withOpacity from '@shared/components/utils/hoc/withOpacity';
import { OFFSET } from '@shared/types/constants/animations';

/**
 * Props for the DescriptionContentContainer component.
 */
interface Props {
  menuExpanded?: boolean;
}

/**
 * Styled description content container.
 */
const DescriptionContentContainer = styled.div.attrs({
  id: 'descriptionContainer',
})<Props>`
  display: flex;
  flex-direction: column;
  height: ${525 * Screen.widthRatio}px;
  left: ${120 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
  pointer-events: none;
  position: absolute;
  top: ${54 * Screen.widthRatio}px;
  transform: translateX(
    ${(props) =>
      Screen.widthRatio *
      (props.menuExpanded
        ? OFFSET.MAIN_HORIZONTAL.COLLAPSED
        : OFFSET.MAIN_HORIZONTAL.EXPANDED)}px
  );
  width: 100%;
  z-index: 1;
`;

export default withOpacity(DescriptionContentContainer);
